import { atom } from 'recoil'

export const cartState = atom({
    key: 'cartAtom',
    default: [],
})
